__turbopack_context__.v({
  "coverButton": "work-large-cover-module-scss-module__WfdhXq__coverButton",
  "largeCover": "work-large-cover-module-scss-module__WfdhXq__largeCover",
  "modal": "work-large-cover-module-scss-module__WfdhXq__modal",
  "modalContent": "work-large-cover-module-scss-module__WfdhXq__modalContent",
  "u-animation-bounce": "work-large-cover-module-scss-module__WfdhXq__u-animation-bounce",
});
